import api from './api';

export const leaderService = {
  // Dashboard
  getDashboard: async () => {
    try {
      const response = await api.get('/leader/dashboard');
      return response.data;
    } catch (error) {
      console.error('Error fetching leader dashboard:', error);
      throw error;
    }
  },

  // Team Management
  getFullTeam: async (params) => {
    try {
      const response = await api.get('/leader/team', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching full team:', error);
      throw error;
    }
  },

  getTeamMemberDetails: async (userId) => {
    try {
      const response = await api.get(`/leader/team/member/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching team member details:', error);
      throw error;
    }
  },

  getTeamPerformance: async () => {
    try {
      const response = await api.get('/leader/team/performance');
      return response.data;
    } catch (error) {
      console.error('Error fetching team performance:', error);
      throw error;
    }
  },

  getTeamCommissions: async (params) => {
    try {
      const response = await api.get('/leader/team/commissions', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching team commissions:', error);
      throw error;
    }
  },

  // Reports
  downloadTeamReport: async (params) => {
    try {
      const response = await api.get('/leader/team/report/download', {
        params,
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error('Error downloading team report:', error);
      throw error;
    }
  }
};